(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["who-quick-add"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__whoQuickAdd) return;
  window.__whoQuickAdd = true;

  var LABEL = 'Quick add +';

  /* Who Crew cards: send image and title links to the landing page */
  function linkCrewCards(scope) {
    (scope || document).querySelectorAll('[data-who-crew]').forEach(function (box) {
      var url = box.getAttribute('data-who-crew');
      var card = box.closest('.ProductItem') || box.parentNode;
      if (!card) return;
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        a.setAttribute('href', url);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { linkCrewCards(); });
  } else {
    linkCrewCards();
  }

  /* Re-run when Prestige reloads the grid (filters, sorting, pagination) */
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; linkCrewCards(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function openCart() {
    if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
    if (typeof window.upcartOpenCart === 'function') { try { window.upcartOpenCart(); return; } catch (e) {} }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    if (!document.querySelector('upcart-root, #upCart, [id*="upcart" i]')) window.location.href = '/cart';
  }

  function reset(btn) {
    setTimeout(function () {
      btn.disabled = false;
      btn.textContent = LABEL;
    }, 1800);
  }

  document.addEventListener('click', function (e) {
    var size = e.target.closest('[data-who-size]');
    if (size && !size.disabled) {
      e.preventDefault();
      var box = size.closest('[data-who-qa]');
      box.querySelectorAll('[data-who-size]').forEach(function (b) { b.classList.remove('is-selected'); });
      size.classList.add('is-selected');
      box.setAttribute('data-variant', size.getAttribute('data-who-size'));
      var btn = box.querySelector('[data-who-add]');
      if (btn && !btn.disabled) btn.textContent = LABEL;
      return;
    }

    var add = e.target.closest('[data-who-add]');
    if (!add || add.disabled) return;
    e.preventDefault();

    var wrap = add.closest('[data-who-qa]');
    var id = wrap.getAttribute('data-variant');
    if (!id) {
      add.textContent = 'Select a size';
      add.classList.remove('is-prompt'); void add.offsetWidth; add.classList.add('is-prompt');
      return;
    }

    add.disabled = true;
    add.textContent = 'Adding';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      add.textContent = 'Added';
      openCart();
    }).catch(function () {
      add.textContent = 'Try again';
    }).finally(function () {
      reset(add);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
